import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=bf607f28&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=bf607f28&scoped=true&lang=stylus"
import style1 from "./Shop.vue?vue&type=style&index=1&id=bf607f28&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf607f28",
  null
  
)

export default component.exports